import {
  apiAddBillingWallet,
  apiDeleteBillingWallet,
  apiGetBillingWallets,
  apiUpdateBillingWallet,
} from "@lib/api/wallet";
import { UseQueriesProps } from "@lib/types/General";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export const useWalletQueries = (props: UseQueriesProps) => {
  const { queryKey, params, id, messages, enabled = true, onSuccess } = props;
  const queryKeys = queryKey || [
    "wallet",
    params ? JSON.stringify(params) : id,
  ];
  const queryClient = useQueryClient();

  const walletsQuery = useQuery({
    queryFn: () => apiGetBillingWallets(params),
    queryKey: queryKeys,
    enabled: !!params && !!enabled,
  });

  const addWalletMutation = useMutation({
    mutationFn: apiAddBillingWallet,
    onSuccess() {
      toast.success(
        (messages["common.createdMessage"] as string).replace(
          "{name}",
          messages["common.wallet"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
      onSuccess?.();
    },
  });

  const updateWalletMutation = useMutation({
    mutationFn: apiUpdateBillingWallet,
    onSuccess() {
      toast.success(
        (messages["common.updatedMessage"] as string).replace(
          "{name}",
          messages["common.wallet"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
      onSuccess?.();
    },
  });

  const deleteWalletMutation = useMutation({
    mutationFn: apiDeleteBillingWallet,
    onSuccess() {
      toast.success(
        (messages["common.deletedMessage"] as string).replace(
          "{name}",
          messages["common.wallet"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
      onSuccess?.();
    },
  });

  return {
    walletsQuery,
    addWalletMutation,
    updateWalletMutation,
    deleteWalletMutation,
  };
};
